import {
	useFormErrorNotification,
	useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { ShopDto, VerifyNewShopDomainDto } from "../generated/schema";
import { useInvalidateShopDomains } from "./use-shop-domains";

export default function useAddDomain(shop: ShopDto) {
	const successNotification = useFormSuccessNotification();
	const errorNotification = useFormErrorNotification();
	const invalidateShopDomains = useInvalidateShopDomains(shop.id);

	const mutation = $api.useMutation(
		"post",
		"/shops/{shopId}/preferences/notifications/domains",
	);

	return useMutation({
		onSuccess: () => {
			invalidateShopDomains();
			successNotification();
		},
		onError: () => {
			errorNotification();
		},
		mutationFn: (body: VerifyNewShopDomainDto) => {
			return mutation.mutateAsync({
				params: { path: { shopId: shop.id } },
				body,
			});
		},
	});
}
